const moment = require("moment-timezone");

exports.getSAM = (sam) => {
  let val = moment.utc(sam * 1000).format("HH[h]mm[m]ss");
  if (Math.round((sam % 1) * 10) != 0)
    val = val + "." + Math.round((sam % 1) * 10);
  val += "s";
  return val;
};
